import axios from 'axios'
import router from '@/router';
import api from '@/api';

export const motivationModule = {
    namespaced: true,

    state:() => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        defaultDate: [],
        excelData: {},
        excelSended: false,
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data
        },

        setReportFilterset(state, data) {
            // Сброс фильтров дат и времени
            state.filterSpecs['date_range'] = [];
            state.filterSpecs['time_range'] = [];

            const queries = router.currentRoute.value.query;

            if (Object.keys(queries).length === 0) {
                // Если нет query-параметров, выставляем фильтры по умолчанию из filterset
                Object.entries(data).forEach(([filter, filterData]) => {
                    if (filter === 'title') return;

                    if (filter === 'date_range') {
                        state.filterSpecs[filter] = filterData.choices.map(choice => choice.value);
                    } else if (filter === 'time_range') {
                        const nullValue = filterData.choices.find(x => !x.value);
                        if (!nullValue) {
                            state.filterSpecs[filter] = filterData.choices.slice(0, 2).map(choice => {
                                const [hours = '', minutes = ''] = (choice.value || '').split(':');
                                return { hours, minutes };
                            });
                        } else {
                            state.filterSpecs[filter] = [
                                { hours: '', minutes: '' },
                                { hours: '', minutes: '' }
                            ];
                        }
                    } else {
                        const checked = filterData.choices.find(choice => choice.checked);
                        state.filterSpecs[filter] = checked ? checked.value : '';
                    }
                });
            } else {
                // Если есть query-параметры, выставляем фильтры из них
                state.filterSpecs['date_range'] = [
                    queries.date_from || '',
                    queries.date_to || ''
                ];

                state.filterSpecs['shop'] = queries.shop ? Number(queries.shop) : '';

                if (queries.time_from || queries.time_to) {
                    state.filterSpecs['time_range'] = [
                        {
                            hours: queries.time_from ? queries.time_from.split(':')[0] : '00',
                            minutes: queries.time_from ? queries.time_from.split(':')[1] : '00'
                        },
                        {
                            hours: queries.time_to ? queries.time_to.split(':')[0] : '23',
                            minutes: queries.time_to ? queries.time_to.split(':')[1] : '00'
                        }
                    ];
                } else {
                    state.filterSpecs['time_range'] = [
                        { hours: '', minutes: '' },
                        { hours: '', minutes: '' }
                    ];
                }
            }

            state.filterset = data;
            state.filtersetLoading = false;
        },

        setExcelData(state, data) {
            state.excelData = data
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true
            // Проверяет, есть ли параметры которые можно передать в запросе
            if(router.currentRoute.value.fullPath.split('?')[1]) {
                try {
                    const response = await axios.get(api + "reports/motivation/data?" + router.currentRoute.value.fullPath.split('?')[1], {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    console.log(response.data);
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await axios.get(api + "reports/motivation/data", {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                    console.log(response.data);
                    commit('setReportData', response.data.data)
                    commit('setExcelData', response.data)
                } catch(err) { // Если есть ошибка
                    alert(err)
                }
            }

            state.reportLoading = false
        },

        async getReportFilterset({ commit, state }) {
            try {
                const response = await axios.get(api + "reports/motivation/filterset", {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                commit('setReportFilterset', response.data)
                state.filtersetLoading = false
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        resetFilters({ state }) {
            for(let filter in state.filterset) {
                state.filterSpecs[filter] = []

                if(filter !== 'title') {
                    for(let i = 0; i < state.filterset[filter].choices.length; i++) {
                        if(filter === 'date_range') {
                            state.filterSpecs[filter].push(state.filterset[filter].choices[i].value)
                        } else {
                            if(state.filterset[filter].choices[i].checked) {
                                state.filterSpecs[filter] = state.filterset[filter].choices[i].value
                            }
                        }
                    }
                }
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await axios.post(api + "reports/export_to_excel/",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                    responseType: 'blob'
                })
                const now = new Date()
                const url = URL.createObjectURL(response.data)
                const a = document.createElement('a')
                a.href = url
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
                URL.revokeObjectURL(url)
                
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },

        async sendExcelFileTG({ state }) {
            try {
                const response = await axios.post(api + "reports/export_to_excel/?send_to_tg=true",
                state.excelData,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    },
                })

                state.excelSended = response.data.success

                setTimeout(() => state.excelSended = false, 5000);
            } catch(err) { // Если есть ошибка
                alert(err)
            }
        },
    }
}